import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@mezzodevelopment/mezzo-ui/auth';
import { Loader } from '../../components/loader';

export const AuthCallback = () => {
  const { user, getAuthCallback, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && !user) getAuthCallback({ redirect: '/' });
  }, [user, isLoading, getAuthCallback]);

  if (isLoading) return <Loader />;
  if (user) return <Navigate to="/" />;
  return null;
};
